import { gql } from '@common/hooks';

const OrganizationFragment = gql`
  fragment OrganizationFragment on Organization {
    id
    name
    code
    logoAvatarUrl
    dashboardUrl
    entityType
    billingEnabled
    sourcingEnabled
    requiresAcceptTermsConditions
    internationalAsDefault
    organizationBusinessesActiveCount
    worksProgramsCount
    onDemandEnabled
    defaultTimeZone
    organizationSetting {
      id
      timekeepingEnabled
    }
    authProviders {
      id
      provider
      name
      url
    }
  }
`;

const SupplierFragment = gql`
  fragment SupplierFragment on Supplier {
    id
    name
    code
    entityType
    address
    city
    country
    phoneNumber
    postalCode
    stateCode
    website
    defaultTimeZone
    defaultContact {
      id
      name
    }
    authProviders {
      id
      provider
      name
      url
    }
  }
`;

export const CurrentEntityContextQuery = gql`
  query CurrentEntityQuery {
    currentEntity {
      __typename

      ... on Organization {
        ...OrganizationFragment
      }

      ... on Supplier {
        ...SupplierFragment
      }
    }
  }
  ${OrganizationFragment}
  ${SupplierFragment}
`;

export type CurrentEntityContextQueryResponse = {
  currentEntity: CurrentEntityType;
};

export type CurrentEntityType = {
  id: string;
  code: string;
  name: string;
  entityType: string;
  address: string;
  city: string;
  country: string;
  defaultTimeZone?: string;
  defaultContact: {
    id: string;
    name: string;
  };
  onDemandEnabled: boolean;
  phoneNumber: string;
  postalCode: string;
  stateCode: string;
  website: string;
  worksProgramsCount?: number;
  internationalAsDefault: boolean;
  requiresAcceptTermsConditions: boolean;
};
